import { useEffect, useState } from "react";
import ongoingProjectAgsColonyNemilichery from "../../assets/images/projects/ongoingProjects/ongoingProjectAgsColonyNemilichery.png";
import ongoingProjectKundrathur from "../../assets/images/projects/ongoingProjects/ongoingProjectKundrathur.png";
import ongoingProjectPerungalathur from "../../assets/images/projects/ongoingProjects/ongoingProjectPerungalathur.png";
import completedProjectOmsakthinagar from "../../assets/images/projects/completedProjects/completedProjectOmsakthinagar.png";
import completedProjectKannamanagar from "../../assets/images/projects/completedProjects/completedProjectKannamanagar.png";
import completedProjectChitlapakam from "../../assets/images/projects/completedProjects/completedProjectChitlapakam.png";
import completedProjectKurunjinagar from "../../assets/images/projects/completedProjects/completedProjectKurunjinagar.png";
import completedProjectGandhinagar from "../../assets/images/projects/completedProjects/completedProjectGandhinagar.png";
import ProjectCard from "./projectCard/projectCard";
import Testimonials from "../testimonials/testimonials";


const Projects: React.FC = () => {

    const [activeTab, setActiveTab] = useState("ongoing");

    type Project = {
        projectName: string;
        description: string;
        budget: string;
        size: string;
        type: string;
        status: string;
        location: string;
        flat: string;
        services: string[];
        image1: string;
        image2: string;
    };

    const ongoingProjects: Project[] = [
        {
            projectName: "Project Kundrathur",
            description: "Under construction using high-quality materials, modern waterproofing, and precision electrical work to deliver durability and efficiency upon completion.",
            budget: "???",
            size: "???",
            type: "???",
            status: "Ongoing",
            location: "Kundrathur",
            flat: "???",
            services: ["???", "???"],
            image1: ongoingProjectKundrathur,
            image2: ongoingProjectKundrathur,
        },
        {
            projectName: "Project AGS Colony Nemilichery",
            description: "Currently under development with premium materials, advanced waterproofing, and efficient electrical systems to ensure long-term strength and safety.",
            budget: "???",
            size: "???",
            type: "???",
            status: "Ongoing",
            location: "Ags Colony Nemilichery",
            flat: "???",
            services: ["???", "???"],
            image1: ongoingProjectAgsColonyNemilichery,
            image2: ongoingProjectAgsColonyNemilichery,
        },

        {
            projectName: "Project Perungalathur",
            description: "In progress with top-grade materials, innovative waterproofing, and reliable electrical infrastructure to create a secure and lasting living space.",
            budget: "???",
            size: "???",
            type: "???",
            status: "Ongoing",
            location: "Perungalathur",
            flat: "???",
            services: ["???", "???"],
            image1: ongoingProjectPerungalathur,
            image2: ongoingProjectPerungalathur,
        },
    ];

    const completedProjects: Project[] = [
        {
            projectName: "Project Omsakthinagar",
            description: "Crafted with high-quality materials, advanced waterproofing, and efficient electrical infrastructure, this home offers long-term durability, comfort, and reliability.",
            budget: "Confidential",
            size: "3000",
            type: "Residential",
            status: "Done",
            location: "Omsakthinagar",
            flat: "3 Units of 2BHK,3BHK,3BHK",
            services: ["Pre-construction services","General contracting","Residential & commercial construction","Joint venture development","Repairs & renovations","Paintings"],
            image1: completedProjectOmsakthinagar,
            image2: completedProjectOmsakthinagar,
        },
        {
            projectName: "Project Kannama Nagar",
            description: "Designed using premium materials, moisture-resistant waterproofing, and high-performance wiring, ensuring a secure, resilient, and enduring living space.",
            budget: "Confidential",
            size: "2400",
            type: "Individual",
            status: "Done",
            location: "Kannama Nagar",
            flat: "2 Units of 2BHK",
            services: ["Pre-construction services","General contracting","Residential & commercial construction","Joint venture development","Repairs & renovations","Paintings"],
            image1: completedProjectKannamanagar,
            image2: completedProjectKannamanagar,
        },
        {
            projectName: "Project Chitlapakam",
            description: "Constructed with top-tier materials, innovative waterproofing, and expertly installed electrical systems, delivering lasting protection, efficiency, and peace of mind.",
            budget: "Confidential",
            size: "3000",
            type: "Residential",
            status: "Done",
            location: "Chitlapakam",
            flat: "3 Units of 1BHK,1BHK,3BHK",
            services: ["Pre-construction services","General contracting","Residential & commercial construction","Joint venture development","Repairs & renovations","Paintings"],
            image1: completedProjectChitlapakam,
            image2: completedProjectChitlapakam,
        },
        {
            projectName: "Project Kurunjinagar",
            description: "Engineered with exceptional materials, advanced waterproofing treatments, and modern electrical setups, guaranteeing a safe, durable, and future-ready home.",
            budget: "Confidential",
            size: "3200",
            type: "Residential",
            status: "Done",
            location: "Chitlapakam",
            flat: "2 Units of 1BHK,2BHK,3BHK",
            services: ["Pre-construction services","General contracting","Residential & commercial construction","Joint venture development","Repairs & renovations","Paintings"],
            image1: completedProjectKurunjinagar,
            image2: completedProjectKurunjinagar,
        },
        {
            projectName: "Project Gandhinagar",
            description: "Built with superior materials, cutting-edge waterproofing, and precision electrical systems, this space ensures lasting strength, safety, and functionality for years to come.",
            budget: "Confidential",
            size: "4000",
            type: "Community Hall",
            status: "Done",
            location: "Gandhinagar",
            flat: "2 floors of 2000sqft each",
            services: ["Pre-construction services","General contracting","Residential & commercial construction","Joint venture development","Repairs & renovations","Paintings"],
            image1: completedProjectGandhinagar,
            image2: completedProjectGandhinagar,
        },
    ];

    const displayedProjects = activeTab === "ongoing" ? ongoingProjects : completedProjects;

    useEffect(() => {
        const images = [
            ongoingProjectAgsColonyNemilichery,
            ongoingProjectKundrathur,
            ongoingProjectPerungalathur,
            completedProjectOmsakthinagar,
            completedProjectKannamanagar,
            completedProjectChitlapakam,
            completedProjectKurunjinagar,
            completedProjectGandhinagar
        ];

        const loadImages = images.map(src => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = src;
                img.onload = resolve;
                img.onerror = reject;
            });
        });

        Promise.all(loadImages)
            .catch(err => console.error("Failed to load images", err));
    }, []);

    return (
        <>
            <div className="project-tabs-container">
                <div className="project-tabs-wrapper">
                    <div className="project-tab-item">
                        <span
                            className={`project-tab ${activeTab === "ongoing" ? "project-tab-active" : ""}`}
                            onClick={() => setActiveTab("ongoing")}
                        >
                            ONGOING PROJECTS
                            <span className="project-tab-underline"></span>
                        </span>
                    </div>
                    <div className="project-tab-separator"></div>
                    <div className="project-tab-item">
                        <span
                            className={`project-tab ${activeTab === "completed" ? "project-tab-active" : ""}`}
                            onClick={() => setActiveTab("completed")}
                        >
                            COMPLETED PROJECTS
                            <span className="project-tab-underline"></span>
                        </span>
                    </div>
                </div>
            </div>

            <div className="project-list">
                {displayedProjects.map((cardData, index) => (
                    <ProjectCard key={index} cardData={cardData} />
                ))}
            </div>

            <Testimonials />
        </>
    );
};

export default Projects;
